import { Icon, Text } from '@cubeyou-team/hx-react-components';
import React, { useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';

import { APPS_MAP } from '../../constants/config';
import { isAvailableAddon } from '../../utils/AuthHelperMethods';
import {
  StyledAudiencesOpeners,
  StyledAudiencesOpenersRow,
  StyledAudiencesOpenersWrapper,
  StyledColumn,
} from './StyledAudiencesOpeners';
import AudienceOpener from './components/AudienceOpener';

const AudiencesOpeners = ({ apps, onItemDrop, overlapping }) => {
  const tabs = useSelector(state => state.tabs);
  const droppingEntities = useSelector(
    state => state.repository.droppingEntities
  );

  const pendingAudiencesToCompare =
    droppingEntities?.[APPS_MAP.COMPARE]?.length > 0;

  const isDisabled = useCallback(
    name => name !== APPS_MAP.COMPARE && pendingAudiencesToCompare,
    [pendingAudiencesToCompare]
  );

  const renderedApps = useMemo(
    () => apps.filter(app => isAvailableAddon(app.name)),
    [apps]
  );

  const hasRequiredRenderedApps = useMemo(
    () =>
      renderedApps.some(app =>
        ['analyze', 'segmentation', 'compare'].includes(app.name)
      ),
    [renderedApps]
  );

  const shouldApplyOverlapping = useMemo(() => {
    const hasTabs = tabs.list && tabs.list.length > 0;
    return overlapping && hasRequiredRenderedApps && hasTabs;
  }, [overlapping, hasRequiredRenderedApps, tabs.list]);

  return (
    <StyledAudiencesOpeners
      data-testid="audiences-openers"
      overlapping={shouldApplyOverlapping}
    >
      <div className="flex flex-col items-center gap-4 w-full mx-auto">
        {(!tabs.list || tabs.list.length === 0) && (
          <div className="flex items-center gap-2 w-full">
            <Icon
              variant="dark_lighter"
              size="xxlarge"
              icon="icon-arrow_circle_left"
            />
            <Text size="xheadline" style={{ maxWidth: '450px' }}>
              Drag & drop an audience from the left to either be{' '}
              <span className="font-bold">ANALYZED, SEGMENTED</span> or{' '}
              <span className="font-bold">COMPARED</span>
            </Text>
          </div>
        )}
        <StyledAudiencesOpenersWrapper>
          <StyledAudiencesOpenersRow>
            {apps.map((app, index) => {
              return (
                <React.Fragment key={`app-${index}-${app.id}`}>
                  {isAvailableAddon(app.name) && (
                    <StyledColumn key={`${index}-${app.id}`}>
                      <AudienceOpener
                        app={app}
                        isDisabled={isDisabled(app.name)}
                        onItemDrop={onItemDrop}
                      />
                    </StyledColumn>
                  )}
                </React.Fragment>
              );
            })}
          </StyledAudiencesOpenersRow>
        </StyledAudiencesOpenersWrapper>
      </div>
    </StyledAudiencesOpeners>
  );
};

AudiencesOpeners.defaultProps = {
  apps: [],
};

export default AudiencesOpeners;
